module.exports = __webpack_public_path__ + "static/media/3-hour.6789a2f9.png";